import React, { createContext, useContext, useState } from 'react'
import { createStore, useStore } from 'zustand'
import type { StoreApi } from 'zustand'

interface WidgetState {
  widgetDisplayType: string
  open: boolean
  loaded: boolean
  actions: {
    openWidget: () => void
    closeWidget: () => void
    toggleWidget: () => void
    toggleDisplay: () => void
  }
}

const createWidgetStore = () =>
  createStore<WidgetState>((set) => {
    return {
      widgetDisplayType: 'large',
      open: false,
      loaded: false,
      actions: {
        openWidget: () => {
          set({
            open: true,
            loaded: true
          })
        },
        closeWidget: () => {
          set({
            open: false,
            loaded: true
          })
        },
        toggleWidget: () => {
          set((state) => ({
            open: !state.open,
            loaded: true
          }))
        },
        toggleDisplay: () => {
          set((state) => ({
            widgetDisplayType:
              state.widgetDisplayType === 'large' ? 'thumbnail' : 'large'
          }))
        }
      }
    }
  })

const WidgetContext = createContext<StoreApi<WidgetState> | null>(null)

const useWidgetStore = <T,>(selector: (state: WidgetState) => T): T => {
  const store = useContext(WidgetContext)
  if (!store) throw new Error('Retorik Framework > useWidgetStore must be used within WidgetProvider')
  return useStore(store, selector)
}

const WidgetProvider = ({ children }) => {
  const [store] = useState(() => createWidgetStore())

  return (
    <WidgetContext.Provider value={store}>{children}</WidgetContext.Provider>
  )
}

export default WidgetProvider
export { useWidgetStore }
